var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRelay3Off(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54221 8.56863L10.3865 3.24571C10.4197 3.19985 10.4915 3.23562 10.4749 3.28969L9.39313 6.80532C9.33377 6.99824 9.47802 7.19355 9.67987 7.19355H11.2384C11.3607 7.19355 11.4316 7.33217 11.36 7.43137L7.4831 12.7994C7.45116 12.8436 7.38158 12.812 7.39385 12.7588L8.22114 9.17391C8.26452 8.98592 8.12175 8.80645 7.92882 8.80645H6.66382C6.54145 8.80645 6.47057 8.66782 6.54221 8.56863Z",
    fill: "#23D4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 15C6.75 14.586 6.414 14.25 6 14.25C5.586 14.25 5.25 14.586 5.25 15C5.25 15.414 5.586 15.75 6 15.75C6.414 15.75 6.75 15.414 6.75 15Z",
    fill: "#23D4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 15C9.75 14.586 9.414 14.25 9 14.25C8.586 14.25 8.25 14.586 8.25 15C8.25 15.414 8.586 15.75 9 15.75C9.414 15.75 9.75 15.414 9.75 15Z",
    fill: "#23D4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 15C12.75 14.586 12.414 14.25 12 14.25C11.586 14.25 11.25 14.586 11.25 15C11.25 15.414 11.586 15.75 12 15.75C12.414 15.75 12.75 15.414 12.75 15Z",
    fill: "#23D4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelay3Off);
export default __webpack_public_path__ + "static/media/relay-3-off.ddfa3b51f03eb0cd3b18b4343f437dbf.svg";
export { ForwardRef as ReactComponent };